var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var buttonElement = require('../components/button');
var flash = require('../components/flash');

var state = {
  organizationName: prop(''),
  loaded: prop(false),
  loading: true,
  saving: false,
  message: prop([]),
  error: prop([])
};

function resetAlerts() {
  state.message([]);
  state.error([]);
}

function setMessage(items) {
  state.message(items);
}

function setError(items) {
  state.error(items);
}

function loadSettings() {
  resetAlerts();
  state.loaded(false);
  state.loading = true;
  return loaders.requestWithLoader({
    loader: 'main',
    method: 'GET',
    url: '/api/v1/general/settings',
  })
  .then(function (res) {
    if (!res || typeof res !== 'object') {
      setError(['Failed to load general settings']);
      return;
    }
    state.organizationName(res.organizationName || '');
    state.loaded(true);
  })
  .catch(function (err) {
    const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to load general settings');
    setError([msg]);
  })
  .finally(function () {
    state.loading = false;
  });
}

function saveSettings() {
  resetAlerts();
  var organizationName = String(state.organizationName() || '').trim();

  if (!organizationName) {
    setError(['Organization name is required']);
    return;
  }

  state.saving = true;
  return loaders.requestWithLoader({
    loader: 'submit',
    method: 'PUT',
    url: '/api/v1/general/settings',
    body: {
      organizationName: organizationName
    }
  })
  .then(function (res) {
    if (res && typeof res === 'object') {
      state.organizationName(res.organizationName || organizationName);
    }
    setMessage(['Saved general settings']);
  })
  .catch(function (err) {
    const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to save general settings');
    setError([msg]);
  })
  .finally(function () {
    state.saving = false;
  });
}

var generalSettings = {
  oninit: function () {
    return loadSettings();
  },
  view: function () {
    var content = null;
    if (state.loading) {
      content = m('div.tc', [
        m('img.h1', { src: '/images/loading-bars.svg' })
      ]);
    } else if (state.loaded()) {
      content = m('div', [
        m('div.mb3', [
          m('label.db', 'Organization Name'),
          m('input.form-control.w-50-ns', {
            type: 'text',
            autocomplete: 'off',
            value: state.organizationName(),
            oninput: function (e) {
              state.organizationName(e.target.value);
            }
          })
        ]),
        m('div.mt2.flex.justify-end', [
          m(buttonElement, {
            label: state.saving ? 'Saving...' : 'Save',
            class: 'green',
            style: { minWidth: '33%' },
            func: saveSettings
          })
        ])
      ]);
    }
    return m('div', [
      m('h3.mt0', 'General'),
      state.error() && state.error().length ? m(flash, { items: state.error(), bg: 'bg-red' }) : null,
      state.message() && state.message().length ? m(flash, { items: state.message(), bg: 'bg-green' }) : null,
      content
    ]);
  }
};

module.exports = generalSettings;
